import React, { memo } from 'react'
import { Grid } from '@mui/material'

import Text from '../text/Text'

const GridItem = ({
  label,
  isCurrent,
  value,
  isValueBold = true,
  labelStyles,
  valueStyles,
  sx
}) => {
  return (
    <Grid container spacing={0.5} sx={sx}>
      <Grid item xs={12} sm={8}>
        <Text
          variant='body1'
          label={label}
          fontSize='1.125rem'
          {...labelStyles}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Text
          variant='body1'
          label={value}
          fontWeight={isValueBold && 900}
          fontSize='1.125rem'
          textAlign='right'
          color={isCurrent && 'primary.main'}
          {...valueStyles}
        />
      </Grid>
    </Grid>
  )
}

export default memo(GridItem)
